import { render, staticRenderFns } from "./DiskMonitoring.vue?vue&type=template&id=2d41f25c&scoped=true"
import script from "./DiskMonitoring.vue?vue&type=script&lang=js"
export * from "./DiskMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41f25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d41f25c')) {
      api.createRecord('2d41f25c', component.options)
    } else {
      api.reload('2d41f25c', component.options)
    }
    module.hot.accept("./DiskMonitoring.vue?vue&type=template&id=2d41f25c&scoped=true", function () {
      api.rerender('2d41f25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/monitor/DiskMonitoring.vue"
export default component.exports